import React, { Component } from 'react';
import '../../styles/css/ProjectCards/DetailCard.css';
import SecirityIcon from '@material-ui/icons/Security';
import StarRateIcon from '@material-ui/icons/StarRate';
import StarRatingComponent from 'react-star-rating-component';

class ProfileCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    render() {

        const { cardData } = this.props;

        return (
            <div className="detailCardRoot">
                <div className="detailCardMain">
                    <div className="detailCardTitle">
                        <div>
                            <div className="nameMain">
                                <span>{cardData.name}</span>
                                <SecirityIcon />
                            </div>
                            <div>
                                <StarRatingComponent
                                    name="rate1"
                                    starCount={5}
                                    value={Math.round(cardData.rating, 10)}
                                    starColor={"#9cd5f1"}
                                    emptyStarColor={"#b1b1b1"}
                                    renderStarIcon={() => <StarRateIcon style={{ width: '20px' }} />}
                                    editing={false}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default ProfileCard;


// WEBPACK FOOTER //
// ./src/pages/Users/ProfileCard.js